import { render, staticRenderFns } from "./sideboardDevice.vue?vue&type=template&id=22919717&scoped=true&"
import script from "./sideboardDevice.vue?vue&type=script&lang=js&"
export * from "./sideboardDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22919717",
  null
  
)

export default component.exports